/*
 * Discounts & Campaigns — storefront hydration.
 *
 * Reads ONE Supabase row (app_settings, key=campaign_config) — the same row
 * the React admin writes and the React builder reads — and hydrates two
 * storefront surfaces from a single fetch:
 *
 *   1. Site banner  [data-campaign-site-banner]  — slim bar above page content
 *   2. PDP label    [data-campaign-pdp-label]     — clickable discount label
 *
 * Both render hidden in Liquid; this script reveals + fills them, so there's
 * no flash when a campaign is inactive. Fails silent (matches the
 * personalisation-* sections' Supabase pattern).
 *
 * The discount code is applied via Shopify's native /discount/<CODE> endpoint,
 * which attaches the code to the cart/session (pre-applied at checkout) and
 * redirects back to the current page.
 */
(function () {
  var SUPA_URL = 'https://oquugatwdfrfnnxjbldg.supabase.co';
  var SUPA_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9xdXVnYXR3ZGZyZm5ueGpibGRnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ4OTgzODksImV4cCI6MjA5MDQ3NDM4OX0.7ixhYEo1eztKqV1oX2MAnHQFuuGPrC6dZKT_krsunTY';

  var siteBanner = document.querySelector('[data-campaign-site-banner]');
  var pdpLabel = document.querySelector('[data-campaign-pdp-label]');

  // Nothing to hydrate on this page.
  if (!siteBanner && !pdpLabel) return;

  function show(el) {
    if (!el) return;
    el.classList.remove('hidden');
  }

  // Render admin text with lightweight **bold** support. HTML is escaped
  // first (so it's safe even though only admins can write the value via
  // RLS), then **...** is turned into <strong>. Lets a campaign emphasise
  // the discount, e.g. "**15% off** with code **SAVE15**".
  function renderRichText(el, raw) {
    var esc = raw
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    el.innerHTML = esc.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  }

  function applySiteBanner(cfg) {
    if (!siteBanner || !cfg || !cfg.enabled) return;
    var text = (cfg.text || '').trim();
    if (!text) return;
    var textEl = siteBanner.querySelector('[data-campaign-site-banner-text]') || siteBanner;
    renderRichText(textEl, text);
    show(siteBanner);
  }

  // Tapping the label hands off to Shopify's /discount/<CODE> route, which
  // sets the discount on the cart/session and RELOADS the page. So an in-page
  // "Coupon applied" swap would be wiped by that reload. We record the code we
  // applied in sessionStorage BEFORE navigating; when the page comes back we
  // render the label in its applied state (tick + confirmation) instead of the
  // tap-to-save CTA. sessionStorage (not local) so it tracks the current
  // browsing session, matching the lifetime of Shopify's discount cookie.
  // Fails silent if storage is blocked (private mode) -- the discount is still
  // really applied, we just fall back to showing the CTA again.
  var APPLIED_KEY = 'aj_campaign_applied_code';
  var TICK_SVG =
    '<svg data-campaign-pdp-tick aria-hidden="true" width="16" height="16" ' +
    'viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M4.5 10.5l3.5 3.5 7.5-8" stroke="currentColor" stroke-width="2.5" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function sessionGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sessionSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

  // Swap the label into its success state: tick icon + confirmation text, no
  // longer clickable.
  function showPdpApplied(textEl, appliedText) {
    if (textEl) textEl.textContent = appliedText;
    if (!pdpLabel.querySelector('[data-campaign-pdp-tick]')) {
      pdpLabel.insertAdjacentHTML('afterbegin', TICK_SVG);
    }
    pdpLabel.disabled = true;
    pdpLabel.style.cursor = 'default';
    pdpLabel.setAttribute('aria-disabled', 'true');
    pdpLabel.classList.remove('hover:bg-indigo-100');
  }

  function applyPdpLabel(cfg) {
    if (!pdpLabel || !cfg || !cfg.enabled) return;
    var text = (cfg.text || '').trim();
    if (!text) return;

    var textEl = pdpLabel.querySelector('[data-campaign-pdp-label-text]') || pdpLabel;
    var code = (cfg.code || '').trim();
    var appliedText = (cfg.applied_text || 'Coupon applied').trim();

    if (code && sessionGet(APPLIED_KEY) === code) {
      // Returned from /discount/<CODE> (or a later page view this session):
      // the code is on the cart/session, so confirm it's applied.
      showPdpApplied(textEl, appliedText);
    } else {
      renderRichText(textEl, text);
      if (code) {
        pdpLabel.addEventListener('click', function () {
          // Record BEFORE navigating -- the /discount route reloads the page.
          sessionSet(APPLIED_KEY, code);
          var redirect = window.location.pathname + window.location.search;
          window.location.href =
            '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
        });
      } else {
        // No code: show the message but make it non-interactive.
        pdpLabel.disabled = true;
        pdpLabel.style.cursor = 'default';
      }
    }

    pdpLabel.classList.remove('hidden');
    pdpLabel.classList.add('inline-flex');
  }

  fetch(SUPA_URL + '/rest/v1/app_settings?key=eq.campaign_config&select=value', {
    headers: { apikey: SUPA_KEY, Authorization: 'Bearer ' + SUPA_KEY }
  })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
    .then(function (rows) {
      var value = Array.isArray(rows) && rows[0] ? rows[0].value : null;
      if (!value || typeof value !== 'object') return;
      applySiteBanner(value.site_banner);
      applyPdpLabel(value.pdp_label);
    })
    .catch(function (e) { console.warn('[aj-campaigns]', e); });
})();
